import PropTypes from "prop-types";
import React from "react";
import Container from "@mui/material/Container";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import typography from "assets/theme/base/typography";

function Footer({ light }) {
  const { size } = typography;

  return (
    <MDBox
      position="relative" // Deixa o rodapé fluido
      mt={4} // Adiciona espaço superior para separá-lo do formulário
      py={2} // Espaçamento interno para o texto
      width="100%" // Ocupa toda a largura
      bgcolor={light ? "transparent" : "rgba(0, 0, 0, 0.6)"} // Fundo transparente ou escuro
    >
      <Container>
        <MDBox
          display="flex"
          justifyContent="center"
          alignItems="center"
          color={light ? "white" : "text"}
          fontSize={size.sm}
        >
          <MDTypography variant="body2" color={light ? "white" : "text"} textAlign="center">
            &copy; {new Date().getFullYear()}, Finnoplan. Todos os direitos reservados.
          </MDTypography>
        </MDBox>
      </Container>
    </MDBox>
  );
}

Footer.defaultProps = {
  light: false,
};

Footer.propTypes = {
  light: PropTypes.bool,
};

export default Footer;
